export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6260.62d703d0.jpg";